import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  IconButton
} from '@mui/material';
import {
  Person as PersonIcon,
  Edit as EditIcon
} from '@mui/icons-material';
import { ZulassungsantragResponse } from '../../types/antrag';
import { PersonTyp, getGeschlechtLabel } from '../../types/halter';

interface HalterdatenCardProps {
  antrag: ZulassungsantragResponse;
  onEdit?: () => void;
}

const HalterdatenCard: React.FC<HalterdatenCardProps> = ({
  antrag,
  onEdit
}) => {
  return (
    <Card elevation={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        avatar={<PersonIcon />}
        title="Halterdaten"
        subheader="Informationen zum Fahrzeughalter"
        action={
          onEdit ? (
            <IconButton 
              onClick={onEdit}
              size="small"
              color="primary"
            >
              <EditIcon />
            </IconButton>
          ) : null
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Persontyp:
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {antrag.halter?.personTyp === PersonTyp.NATUERLICHE_PERSON ? 'Natürliche Person' : 
               antrag.halter?.personTyp === PersonTyp.JURISTISCHE_PERSON ? 'Juristische Person' : 
               'Nicht verfügbar'}
            </Typography>
          </Grid>
          {antrag.halter?.personTyp === PersonTyp.NATUERLICHE_PERSON && (
            <>
              <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">
                  Name:
                </Typography>
                <Typography variant="body1" fontWeight="bold">
                  {antrag.halter?.vorname || antrag.vorname} {antrag.halter?.nachname || antrag.nachname}
                </Typography>
              </Grid>
              {antrag.halter?.geburtsdatum && (
                <Grid item xs={6}>
                  <Typography variant="body2" color="textSecondary">
                    Geburtsdatum:
                  </Typography>
                  <Typography variant="body1">
                    {antrag.halter.geburtsdatum}
                  </Typography>
                </Grid>
              )}
              {antrag.halter?.geburtsort && (
                <Grid item xs={6}>
                  <Typography variant="body2" color="textSecondary">
                    Geburtsort:
                  </Typography>
                  <Typography variant="body1">
                    {antrag.halter.geburtsort}
                  </Typography>
                </Grid>
              )}
              {antrag.halter?.geschlecht && (
                <Grid item xs={6}>
                  <Typography variant="body2" color="textSecondary">
                    Geschlecht:
                  </Typography>
                  <Typography variant="body1">
                    {getGeschlechtLabel(antrag.halter.geschlecht)}
                  </Typography>
                </Grid>
              )}
            </>
          )}
          {antrag.halter?.personTyp === PersonTyp.JURISTISCHE_PERSON && antrag.halter?.firma && (
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Firmenname:
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                {antrag.halter.firma}
              </Typography>
            </Grid>
          )}
          {(antrag.halter?.strasse || antrag.halter?.hausnummer) && (
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Adresse:
              </Typography>
              <Typography variant="body1">
                {[antrag.halter?.strasse, antrag.halter?.hausnummer, antrag.halter?.adresszusatz].filter(Boolean).join(' ')}
              </Typography>
            </Grid>
          )}
          {(antrag.halter?.plz || antrag.halter?.ort) && (
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                PLZ/Ort:
              </Typography>
              <Typography variant="body1">
                {antrag.halter?.plz} {antrag.halter?.ort}
              </Typography>
            </Grid>
          )}
          {(antrag.halter?.email || antrag.email) && (
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                E-Mail:
              </Typography>
              <Typography variant="body1">
                {antrag.halter?.email || antrag.email}
              </Typography>
            </Grid>
          )}
          {antrag.halter?.iban && (
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary">
                IBAN:
              </Typography>
              <Typography variant="body1" fontFamily="monospace">
                {antrag.halter.iban.replace(/(.{4})/g, '$1 ').trim()}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default HalterdatenCard;
